<template>
  <div>
  <div v-if="variant === 'cards'" class="lm-socials">
    <div class="lm-social" v-for="item in socialCards" :key="item.key">
      <span :class="['soc-ico', item.icon]"></span>
      <div class="lm-social-status" :class="{ connected: item.connected }">
        {{ item.connected ? $t('LM_CONNECTED') : $t('LM_NOT_CONNECTED') }}
      </div>
      <button
        v-if="item.connected && item.social"
        type="button"
        class="lm-social-action"
        @click="askDisconnect(item)"
      >
        {{ $t('LM_DISCONNECT') }}
      </button>
      <button
        v-else-if="item.connect"
        type="button"
        class="lm-social-action connect"
        @click="item.connect()"
      >
        {{ $t('LM_CONNECT') }}
      </button>
    </div>
    <ConfirmDialog
      :open="!!pendingDisconnect"
      :title="pendingDisconnect ? $t('LM_DISCONNECT_TITLE', { network: pendingDisconnect.label }) : ''"
      :description="$t('LM_DISCONNECT_BODY')"
      :confirm-label="$t('LM_DISCONNECT')"
      :cancel-label="$t('LM_CANCEL')"
      @confirm="confirmDisconnect"
      @cancel="pendingDisconnect = null"
    />
  </div>
  <div v-else class="mod-socials">
    <span
      :class="['soc-auth', getCurrentSocialTokens.vkToken ? 'active' : '']"
      @click="getVK"
    >
      <span class="soc-ico soc-vk"></span>
      <span
        class="socials-logout"
        v-if="getCurrentSocialTokens.vkToken"
        @click.stop="removeToken('VK')"
      >
        <i class="bi bi-x"></i>
      </span>
    </span>
    <span
      :class="['soc-auth', getCurrentSocialTokens.fbToken ? 'active' : '']"
      @click="getFB"
    >
      <span class="soc-ico soc-fb"></span>
      <span
        class="socials-logout"
        v-if="getCurrentSocialTokens.fbToken"
        @click.stop="removeToken('FB')"
      >
        <i class="bi bi-x"></i>
      </span>
    </span>
    <span
      :class="['soc-auth', getCurrentSocialTokens.igToken ? 'active' : '']"
      @click="getIG"
    >
      <span class="soc-ico soc-ig"></span>
      <span
        class="socials-logout"
        v-if="getCurrentSocialTokens.igToken"
        @click.stop="removeToken('IG')"
      >
        <i class="bi bi-x"></i>
      </span>
    </span>
    <span class="soc-auth active">
      <span class="soc-ico soc-tg"></span>
    </span>    
  </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { AUTH_REMOVE_TOKEN } from '@/store/actions/auth';
import authMethodsMixin from '@/mixins/authMethodsMixin';
import ConfirmDialog from '@/components/modals/ConfirmDialog.vue';

export default {
  name: 'SocialAuthButtons',
  components: { ConfirmDialog },
  mixins: [authMethodsMixin],
  props: {
    selectedAccessEmail: {
      type: String,
      default: null,
    },
    variant: {
      type: String,
      default: 'icons',
    },
  },
  data() {
    return {
      pendingDisconnect: null,
    };
  },
  computed: {
    ...mapGetters(['getSocialTokens', 'getProfile']),
    emailToUse() {
      return this.selectedAccessEmail || this.getProfile.email;
    },
    getCurrentSocialTokens() {
      if (!this.getSocialTokens || !this.emailToUse) return {};
      return this.getSocialTokens[this.emailToUse] || {};
    },
    socialCards() {
      const tokens = this.getCurrentSocialTokens || {};
      return [
        { key: 'vk', icon: 'soc-vk', label: this.$t('COMMON_SOCIALS_VK'), connected: !!tokens.vkToken, social: 'VK', connect: this.getVK },
        { key: 'fb', icon: 'soc-fb', label: this.$t('COMMON_SOCIALS_FB'), connected: !!tokens.fbToken, social: 'FB', connect: this.getFB },
        { key: 'ig', icon: 'soc-ig', label: this.$t('COMMON_SOCIALS_IG'), connected: !!tokens.igToken, social: 'IG', connect: this.getIG },
        { key: 'tg', icon: 'soc-tg', label: this.$t('COMMON_SOCIALS_TG'), connected: true, social: null, connect: null },
      ];
    },
  },
  methods: {
    askDisconnect(item) {
      this.pendingDisconnect = item;
    },
    async confirmDisconnect() {
      const item = this.pendingDisconnect;
      this.pendingDisconnect = null;
      if (item) await this.removeToken(item.social);
    },
    async removeToken(social) {
      await this.$store.dispatch(AUTH_REMOVE_TOKEN, {
        social,
        email: this.emailToUse,
      });
    },
  },
};
</script>